import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useCallback, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { expandedInboxWithSizeMediumState } from 'store/atoms'
import styles from './AppointmentComments.module.sass'
import { useDrawerContext } from 'context/Drawer/DrawerContext'

const AppointmentComments = (props) => {
	const { data, ...attributes } = props
	const expandedInboxMedium = useRecoilValue(expandedInboxWithSizeMediumState)
	const { dispatch } = useDrawerContext()

	const clickItem = useCallback(
		(data) => (event) => {
			event.preventDefault()

			dispatch({
				action: 'OPEN_DRAWER',
				payload: {
					data: { processId: data.processId, id: data.id },
					type: 'CommentThreadDrawer',
				},
			})
		},
		[dispatch]
	)

	const mappedComments = useMemo(
		() =>
			data.comments.map((comment) => {
				return (
					<VStack
						key={comment?.id}
						className={styles['requisition-comment-container']}
						onClick={clickItem({
							id: comment.id,
							processId: comment.processId,
						})}
					>
						<strong>#{comment?.id}</strong>
						<SlidingText>
							<small>{comment.body}</small>
						</SlidingText>
					</VStack>
				)
			}),
		[data.comments, clickItem]
	)

	return (
		<div className={styles['comments-container']}>
			<h5>{data.$cardLabels?.comments}</h5>
			<VStack
				{...attributes}
				className={`${styles['comments']} ${
					expandedInboxMedium && styles['--inbox-open']
				}`}
			>
				{mappedComments}
			</VStack>
		</div>
	)
}

export default AppointmentComments
